import { useCallback, useState } from "react";

import useEffectIfConditionAfterDelay from "seneca-common/utils/hooks/timeout/useEffectIfConditionAfterDelay";
import { logMessage } from "seneca-common/utils/sentry/logError";

const LOG_AFTER_DELAY = 15000;

const logThatStripeHasntLoaded = () =>
  logMessage(
    `StripeJS hasn't loaded after ${LOG_AFTER_DELAY}ms, this user can't send their card details yet.`
  );

export function useCheckStripeHasLoaded() {
  const [loading, setLoading] = useState(true);

  useEffectIfConditionAfterDelay(
    logThatStripeHasntLoaded,
    loading,
    LOG_AFTER_DELAY
  );

  const setLoaded = useCallback(() => setLoading(false), []);

  return [loading, setLoaded];
}
